<template>
    <UiHeader />
    <div>
        <section class="site-container">
            <div class="normal-container pt-10">
                <div class="flex flex-col items-center text-center">
                    <div class="sanity-content content-sanity-content lg:!w-[775px]">
                        <h3>Oops…</h3>
                        <p>
                            De pagina die je zoekt bestaat niet (meer). Waar ben je naar op zoek? We helpen je graag
                            verder!
                        </p>
                    </div>
                </div>
            </div>
        </section>
        <section class="site-container">
            <div
                style="background-color: #ffffff"
                class="padding-normal flex w-full flex-col justify-center space-y-5 text-white lg:flex-row lg:space-y-0 lg:space-x-5">
                <div class="normal-container !flex flex-col space-y-6 md:flex-row md:space-y-0 md:space-x-5 lg:w-full">
                    <a href="/nl/dames/shop/" class="w-full">
                        <div
                            class="boxed:h-[600px] relative flex aspect-[4/5] h-96 w-full items-end justify-center lg:h-[600px] lg:items-end xl:h-[595px]">
                            <img
                                alt="Dames"
                                loading="eager"
                                fetchpriority="high"
                                :srcset="damesSrcset"
                                class="absolute inset-0 aspect-[4/5] h-96 w-full object-cover lg:h-full"
                                :src="damesSrc" />
                            <div class="relative mb-4 w-[50%] space-y-4 text-center lg:mb-12">
                                <h3 class="text-center text-base leading-[23px] md:text-2xl md:leading-[33px]">
                                    Dames
                                </h3>
                                <p class="text-[14px] font-light md:text-[16px]">Shop de nieuwste dameskleding</p>
                                <div class="flex justify-center">
                                    <div class="w-max justify-center">
                                        <!-- span, not <a>: nested anchors get restructured by the HTML parser and break first paint -->
                                        <span
                                            class="btn btn-secondary lg:btn-secondary flex w-max items-center justify-center !px-10 !py-3.5 font-semibold lg:w-max">
                                            Shop nu
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </a>
                    <a href="/nl/heren/shop/" class="w-full">
                        <div
                            class="boxed:h-[600px] relative flex aspect-[4/5] h-96 w-full items-end justify-center lg:h-[600px] lg:items-end xl:h-[595px]">
                            <img
                                alt="Heren"
                                loading="eager"
                                fetchpriority="high"
                                :srcset="herenSrcset"
                                class="absolute inset-0 aspect-[4/5] h-96 w-full object-cover lg:h-full"
                                :src="herenSrc" />
                            <div class="relative mb-4 w-[50%] space-y-4 text-center lg:mb-12">
                                <h3 class="text-center text-base leading-[23px] md:text-2xl md:leading-[33px]">
                                    Heren
                                </h3>
                                <p class="text-[14px] font-light md:text-[16px]">Shop de nieuwste herenkleding</p>
                                <div class="flex justify-center">
                                    <div class="w-max justify-center">
                                        <span
                                            class="btn btn-secondary lg:btn-secondary flex w-max items-center justify-center !px-10 !py-3.5 font-semibold lg:w-max">
                                            Shop nu
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </a>
                </div>
            </div>
        </section>
    </div>
    <UiFooter :siteConfig="siteConfig" />
</template>

<script setup lang="ts">
    import type { NuxtError } from '#app';

    const props = defineProps({
        error: Object as () => NuxtError,
    });

    const damesSrc =
        'https://cdn.sanity.io/images/7v7q4jhw/production/4ec7b0ee8ea9405abf9360958c0b841e2d74c676-1450x1600.jpg?rect=0,110,1450,1381&w=630&h=600&fm=webp';
    const damesSrcset = `${damesSrc} 1x, ${damesSrc} 2x`;
    const herenSrc =
        'https://cdn.sanity.io/images/7v7q4jhw/production/303075a3df8c742ca0fdfc2e788924c38076c0d0-1450x1600.jpg?rect=0,110,1450,1381&w=630&h=600&fm=webp';
    const herenSrcset = `${herenSrc} 1x, ${herenSrc} 2x`;

    // Fetch in setup so the footer renders server-side; fall back to empty so a Sanity failure can't break the error page
    const siteConfig = await useSiteSettings().catch(() => []);

    onMounted(() => {
        if (props.error) {
            $fetch('/api/log-error', {
                method: 'POST',
                body: {
                    statusCode: props.error?.statusCode ?? 'unknown',
                    message: props.error?.message ?? props.error?.statusMessage ?? 'unknown',
                    url: window.location.href,
                    referrer: document.referrer || 'direct',
                    userAgent: navigator.userAgent,
                    platform: navigator.platform,
                    language: navigator.language,
                    screen: `${window.screen.width}x${window.screen.height}`,
                    viewport: `${window.innerWidth}x${window.innerHeight}`,
                    timestamp: new Date().toISOString(),
                },
            }).catch(() => {});
        }
    });
</script>
